import React, { useMemo, useState } from "react";
import DOMPurify from "dompurify";
import Button from "../../../components/Button/Button";
import { toAbsolutePhotoUrl } from "./../../../services/disciplinePhotoServices";

function cn(...c) {
  return c.filter(Boolean).join(" ");
}

const FALLBACK = "/img/no-image.jpg";

const DisciplineCard = ({ title, ageRange, imageSrc, textDiscipline }) => {
  const [open, setOpen] = useState(false);

  const safeHtml = useMemo(() => {
    return DOMPurify.sanitize(textDiscipline || "", {
      USE_PROFILES: { html: true },
    });
  }, [textDiscipline]);

  return (
    <article
      className={cn(
        "group h-full overflow-hidden rounded-3xl",
        "border border-slate-200/70 dark:border-slate-800",
        "bg-white/80 dark:bg-slate-900/60 backdrop-blur",
        "shadow-sm hover:shadow-lg hover:-translate-y-[2px]",
        "transition duration-300 motion-reduce:transition-none",
      )}
    >
      {/* Image + overlay */}
      <div className="relative">
        <img
          src={toAbsolutePhotoUrl(imageSrc) || FALLBACK}
          alt={title}
          loading="lazy"
          decoding="async"
          className={cn(
            "h-52 w-full object-cover",
            "transition duration-500 group-hover:scale-[1.03] motion-reduce:transition-none",
          )}
        />
        <div
          aria-hidden
          className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-slate-950/10 to-transparent"
        />

        <div className="absolute bottom-0 left-0 right-0 p-5">
          <h3 className="text-xl font-extrabold text-white drop-shadow-sm">
            {title}
          </h3>

          {ageRange ? (
            <p className="mt-1 inline-flex items-center rounded-full bg-white/15 px-2.5 py-1 text-xs font-medium text-white ring-1 ring-white/20">
              {ageRange}
            </p>
          ) : null}
        </div>
      </div>

      {/* Bouton uniquement */}
      <div className="p-5">
        <div className="flex justify-center">
          <Button
            text={open ? "Réduire" : "Détails"}
            onClick={() => setOpen((v) => !v)}
            variant="outline"
            size="sm"
            hoverLabel={open ? "Masquer les détails" : "Afficher les détails"}
            ariaExpanded={open}
            ariaControls={`discipline-details-${title}`}
          />
        </div>

        {/* Accordéon animé */}
        <div
          id={`discipline-details-${title}`}
          className={cn(
            "mt-4 grid transition-[grid-template-rows] duration-300",
            "motion-reduce:transition-none",
            open ? "grid-rows-[1fr]" : "grid-rows-[0fr]",
          )}
        >
          <div className="overflow-hidden">
            <div
              className={cn(
                "prose prose-slate dark:prose-invert max-w-none",
                "text-[15px] leading-relaxed",
                "rounded-2xl bg-slate-50/80 dark:bg-slate-950/40",
                "border border-slate-200/60 dark:border-slate-800/60",
                "p-4",

                // ✅ FORCER le gras en blanc en dark
                "dark:[&_strong]:!text-white dark:[&_b]:!text-white",

                // (optionnel) rendre le gras plus “impactant”
                "dark:[&_strong]:font-extrabold dark:[&_b]:font-extrabold",
              )}
              dangerouslySetInnerHTML={{ __html: safeHtml }}
            />
          </div>
        </div>
      </div>
    </article>
  );
};

export default DisciplineCard;
